// order matters. Make sure we load owa-start first as it has the polyfills we need for owa-bundling to work
import { start } from 'owa-start';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';
import getAnonymousBookingsC2BootPromise from './utils/getAnonymousBookingsC2BootPromise';
import runBeforeStart from './utils/runBeforeStart';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "BookingsC2Boot" */ './lazyIndex')
);

const lazyBootstrap = new LazyAction(lazyModule, m => m.bootstrap);

start({
    app: 'BookingsC2',
    runBeforeStart,
    loadBpos: false,
    overrideBootPromises: getAnonymousBookingsC2BootPromise,
    bootstrap: lazyBootstrap,
});
